export const channels = [
  {
    slug: "breaking",
    name: "突发专报",
    short: "突发",
    desc: "正在发生的第一现场，声明、回应、时间线，第一时间直给。",
    icon: "ri-flashlight-fill",
    accent: "primary",
  },
  {
    slug: "flash",
    name: "紧急插播",
    short: "插播",
    desc: "来不及写长文的动向，一句话说清关键进展，随到随更。",
    icon: "ri-alarm-warning-fill",
    accent: "accent",
  },
  {
    slug: "headline",
    name: "头条专递",
    short: "头条",
    desc: "当日最热的瓜情整点送达，重点齐全不遗漏。",
    icon: "ri-newspaper-fill",
    accent: "secondary",
  },
  {
    slug: "deep",
    name: "深度瓜情",
    short: "深挖",
    desc: "不只看结果，更梳理起因、经过与各方说法，把脉络讲透。",
    icon: "ri-search-eye-line",
    accent: "primary",
  },
];

export const breakingTicker = [
  "突发专报｜某音乐节安可环节临时调整，主办方已发布说明",
  "紧急插播｜年度剧集大结局口碑两极，编剧团队首次回应争议桥段",
  "头条专递｜演唱会加场官宣，票务方就退票规则作出统一答复",
  "突发专报｜综艺录制现场物料外泄，节目组回应将启动核查",
  "紧急插播｜代言合作到期官宣解约，双方均称友好结束",
  "头条专递｜跨年晚会阵容名单曝光，主创团队回应名单真伪",
];

export const articles = [
  {
    id: "br-2026-0912-01",
    title: "顶流工作室深夜发声明，合约风波迎来首次正面回应",
    summary:
      "经历连续两日的传闻发酵，当事工作室在凌晨发布长文，就合约期限、分成比例与后续安排逐条作出说明，事件的时间线也随之清晰。",
    channel: "breaking",
    channelName: "突发专报",
    author: "瓜田速递 · 前线组",
    publishedAt: "2026-09-12 00:48",
    dateLabel: "9月12日",
    readTime: 6,
    heat: 98600,
    isTop: true,
    tags: ["突发专报", "合约风波", "工作室声明"],
    image:
      "https://readdy.ai/api/search-image?query=stylized%20night%20cityscape%20with%20warm%20amber%20street%20lights%20and%20deep%20shadow%2C%20abstract%20editorial%20poster%20aesthetic%2C%20subtle%20red%20glow%20highlights%2C%20no%20people%2C%20moody%20artistic%20photography&width=1200&height=820&seq=gt-hero-main-01&orientation=landscape",
    body: [
      {
        heading: "发生了什么",
        paragraphs: [
          "凌晨零时四十八分，当事工作室通过官方渠道发布一份说明长文。文中没有使用常见的模糊措辞，而是按时间顺序列出合作起点、关键节点与协商过程，并首次正面回应了外界的多项猜测。",
          "与以往由粉丝后援会代为发声不同，这次说明由工作室直接署名，语气克制，全文围绕合约期限、工作安排与后续计划三部分展开。",
        ],
      },
      {
        heading: "时间线梳理",
        paragraphs: [
          "早在两周前，相关话题便已在多个平台零星出现，但始终没有明确信源。直到本周一，一段来源不明的录音片段被广泛转发，讨论量在当晚迅速攀升。",
          "周二晚间，另一当事人所在团队沉默以对，进一步放大了外界的想象空间。直到今日凌晨的这份说明，事件才第一次有了可核对的官方表述。",
        ],
      },
      {
        heading: "接下来看什么",
        paragraphs: [
          "说明中提到，后续工作安排将在协商完成后统一公布。这也意味着，短期内仍可能出现新的补充信息。瓜田速递将持续跟进，一旦有确定进展会以紧急插播的形式同步。",
        ],
      },
    ],
  },
  {
    id: "fl-2026-0912-02",
    title: "演唱会安可环节突然取消，票务方当晚给出处理方案",
    summary:
      "现场观众反馈安可曲目临时取消，主办方在散场前通过大屏公告说明原因，并于当晚公布退票与补偿细则。",
    channel: "flash",
    channelName: "紧急插播",
    author: "瓜田速递 · 现场组",
    publishedAt: "2026-09-12 22:15",
    dateLabel: "9月12日",
    readTime: 3,
    heat: 74200,
    isTop: false,
    tags: ["紧急插播", "演唱会", "退票"],
    image:
      "https://readdy.ai/api/search-image?query=abstract%20concert%20stage%20with%20warm%20yellow%20and%20red%20stage%20lights%2C%20silhouetted%20empty%20stage%2C%20no%20recognizable%20people%2C%20atmospheric%20haze%2C%20cinematic%20editorial%20style&width=800&height=520&seq=gt-art-02&orientation=landscape",
    body: [
      {
        heading: "现场情况",
        paragraphs: [
          "演出原定在三首安可曲后结束。当晚第二首结束后，场馆大屏滚动播出公告，说明因场地设备原因，后续曲目调整为提前收尾。",
          "多位观众表示，公告出现时现场一度安静，随后主办方工作人员在通道口引导散场，并发放了纸质说明。",
        ],
      },
      {
        heading: "官方处理方案",
        paragraphs: [
          "当晚二十三时前后，票务方发布处理方案：受影响场次可申请全额退票，选择保留观演记录的观众，后续场次将获得优先购票资格。",
          "公告同时给出申请通道与时间窗口，强调不会以任何形式收取额外手续费。",
        ],
      },
    ],
  },
  {
    id: "hl-2026-0911-03",
    title: "年度剧集大结局口碑反转，编剧团队首度回应争议桥段",
    summary:
      "被讨论了一整周的大结局终于播出，评价从一边倒的质疑转向分裂。编剧团队在收官采访中回应了最关键的三处设定。",
    channel: "headline",
    channelName: "头条专递",
    author: "瓜田速递 · 剧集观察",
    publishedAt: "2026-09-11 20:30",
    dateLabel: "9月11日",
    readTime: 7,
    heat: 66300,
    isTop: false,
    tags: ["头条专递", "剧集", "编剧回应"],
    image:
      "https://readdy.ai/api/search-image?query=warm%20amber%20abstract%20theater%20curtain%20texture%20close%20up%2C%20deep%20shadow%20folds%2C%20artistic%20editorial%20photography%20with%20no%20people%2C%20soft%20grain%2C%20rich%20red%20and%20gold%20tones&width=800&height=520&seq=gt-art-03&orientation=landscape",
    body: [
      {
        heading: "争议从哪来",
        paragraphs: [
          "争议集中在终章的两处转折：一是主要角色的动机在前几集缺少足够铺垫，二是结局采用开放式收束，没有给出观众期待的明确交代。",
          "社交平台上，两派观点几乎同时出现。一方认为这是创作自由，另一方则觉得是收尾仓促。",
        ],
      },
      {
        heading: "编剧怎么说",
        paragraphs: [
          "编剧团队在采访中解释，开放式结局是开拍前就确定的方案，并非临时改动。至于动机铺垫，他们承认剧集节奏在后半程被压缩，部分过场戏份未能保留。",
          "对于是否会有补充内容，团队表示正在评估制作特别篇的可能，但尚无确切时间表。",
        ],
      },
    ],
  },
  {
    id: "dp-2026-0911-04",
    title: "深挖：一场选秀的两年之后，选手们都去了哪里",
    summary:
      "当年热度最高的五位选手，如今的发展路径差异巨大。我们回访了其中三位，试图还原选秀结束后的真实轨迹。",
    channel: "deep",
    channelName: "深度瓜情",
    author: "瓜田速递 · 深度组",
    publishedAt: "2026-09-11 14:05",
    dateLabel: "9月11日",
    readTime: 9,
    heat: 41800,
    isTop: false,
    tags: ["深度瓜情", "选秀", "人物回访"],
    image:
      "https://readdy.ai/api/search-image?query=abstract%20warm%20toned%20studio%20backdrop%20with%20soft%20spotlight%20beam%20and%20dust%20particles%2C%20minimal%20editorial%20aesthetic%2C%20no%20people%2C%20muted%20beige%20and%20ember%20palette&width=800&height=520&seq=gt-art-04&orientation=landscape",
    body: [
      {
        heading: "热度的半衰期",
        paragraphs: [
          "选秀节目往往在结束后的三个月内达到讨论巅峰，随后迅速回落。这种曲线几乎适用于过去五年里的每一档同类节目。",
          "留在行业里的选手，大多在节目结束后的第一年完成了从「选手」到「从业者」的身份转换。",
        ],
      },
      {
        heading: "三条不同的路",
        paragraphs: [
          "有人转入幕后，成为编曲与舞台设计；有人专注线下演出，积累了稳定的观众群；也有人暂时离开，回到校园完成学业。",
          "三条路径没有高下之分，但它们共同指向一个事实：选秀提供的是起点，而不是终点。",
        ],
      },
    ],
  },
  {
    id: "br-2026-0910-05",
    title: "综艺录制现场物料外泄，节目组回应将启动核查流程",
    summary: "未公开的录制片段在夜间被大范围转发，节目组次日发布声明，表示将核查物料流转环节。",
    channel: "breaking",
    channelName: "突发专报",
    author: "瓜田速递 · 前线组",
    publishedAt: "2026-09-10 09:22",
    dateLabel: "9月10日",
    readTime: 4,
    heat: 52700,
    isTop: false,
    tags: ["突发专报", "综艺", "物料外泄"],
    image:
      "https://readdy.ai/api/search-image?query=abstract%20studio%20control%20room%20with%20warm%20screens%20glow%20and%20cables%2C%20no%20people%2C%20cinematic%20moody%20lighting%2C%20deep%20red%20and%20amber%20accents%2C%20editorial%20photography&width=800&height=520&seq=gt-art-05&orientation=landscape",
    body: [
      {
        heading: "外泄内容",
        paragraphs: [
          "被转发的片段时长不足两分钟，画面中可见尚未公布的赛制道具与舞台布景。由于带有明显的剪辑水印，可以判断并非最终播出素材。",
        ],
      },
      {
        heading: "节目组回应",
        paragraphs: [
          "节目组在声明中表示，已启动内部核查，并对物料流转流程进行全面复盘。声明同时感谢观众关心，呼吁不要继续传播未公开素材。",
        ],
      },
    ],
  },
  {
    id: "hl-2026-0910-06",
    title: "跨年晚会阵容名单流出，主创团队回应名单真伪",
    summary: "一份标注为「内部档期表」的名单在多个社群流传，其中包含多位此前未官宣的艺人。主创团队给出了明确回应。",
    channel: "headline",
    channelName: "头条专递",
    author: "瓜田速递 · 资讯组",
    publishedAt: "2026-09-10 18:40",
    dateLabel: "9月10日",
    readTime: 5,
    heat: 48900,
    isTop: false,
    tags: ["头条专递", "跨年晚会", "阵容"],
    image:
      "https://readdy.ai/api/search-image?query=abstract%20fireworks%20bokeh%20over%20warm%20night%20sky%20in%20gold%20and%20red%20tones%2C%20no%20people%2C%20soft%20glow%2C%20artistic%20long%20exposure%20editorial%20style&width=800&height=520&seq=gt-art-06&orientation=landscape",
    body: [
      {
        heading: "名单是怎么流出的",
        paragraphs: [
          "名单最早出现在一个匿名社群，随后被截图转发至多平台。表格包含艺人姓名、档期与节目类型三列，格式相当规整。",
        ],
      },
      {
        heading: "官方回应",
        paragraphs: [
          "主创团队回应称，网传名单并非官方版本，部分信息与实际情况存在出入。正式阵容将以官方渠道分批公布为准。",
        ],
      },
    ],
  },
  {
    id: "fl-2026-0909-07",
    title: "代言合作到期双方官宣结束，均表示以后仍是朋友",
    summary: "品牌方与艺人在同一天发布声明，宣布为期三年的代言合作到期不再续约，措辞友好。",
    channel: "flash",
    channelName: "紧急插播",
    author: "瓜田速递 · 商业组",
    publishedAt: "2026-09-09 11:10",
    dateLabel: "9月9日",
    readTime: 3,
    heat: 33600,
    isTop: false,
    tags: ["紧急插播", "代言", "解约"],
    image:
      "https://readdy.ai/api/search-image?query=minimal%20warm%20beige%20product%20display%20podium%20with%20soft%20shadow%2C%20editorial%20still%20life%2C%20no%20people%2C%20subtle%20terracotta%20accent%2C%20clean%20composition&width=800&height=520&seq=gt-art-07&orientation=landscape",
    body: [
      {
        heading: "双方声明",
        paragraphs: [
          "品牌方在上午发布公告，表示三年合作已圆满完成，未来将把资源集中到新的产品线上。艺人方随后转发并补充感谢。",
          "两份声明的发布时间间隔不足两小时，措辞一致，未出现任何争议性表述。",
        ],
      },
    ],
  },
  {
    id: "dp-2026-0909-08",
    title: "深挖：音乐节涨价背后，成本到底涨在了哪",
    summary:
      "票价连年上浮让不少乐迷直呼吃不消。我们比对了三届音乐节的成本结构，发现场地与安保才是变化最大的两项。",
    channel: "deep",
    channelName: "深度瓜情",
    author: "瓜田速递 · 深度组",
    publishedAt: "2026-09-09 16:28",
    dateLabel: "9月9日",
    readTime: 10,
    heat: 39700,
    isTop: false,
    tags: ["深度瓜情", "音乐节", "成本"],
    image:
      "https://readdy.ai/api/search-image?query=abstract%20outdoor%20festival%20field%20at%20dusk%20with%20warm%20string%20lights%20and%20open%20sky%2C%20no%20people%2C%20soft%20golden%20hour%20tone%2C%20editorial%20photography&width=800&height=520&seq=gt-art-08&orientation=landscape",
    body: [
      {
        heading: "票价涨了多少",
        paragraphs: [
          "单日早鸟票在三年间上浮约三成，双日通票涨幅接近四成。若换算成每小时的现场体验成本，涨幅要更明显一些。",
        ],
      },
      {
        heading: "钱都花在哪",
        paragraphs: [
          "艺人出场费在总成本中的占比基本稳定，真正变化明显的是场地租赁与安保人力。前者受城市用地供给影响，后者则与大型活动的合规要求提升有关。",
          "此外，舞台搭建与音响设备的运输成本也出现了上涨。多位从业者表示，这部分成本很难通过压缩来消化。",
        ],
      },
    ],
  },
  {
    id: "hl-2026-0908-09",
    title: "口碑黑马剧集意外出圈，平台临时追加排播资源",
    summary:
      "开播时几乎没有宣传的小成本剧集，靠观众口口相传走到热度榜前列，平台随即调整了后续排播。",
    channel: "headline",
    channelName: "头条专递",
    author: "瓜田速递 · 剧集观察",
    publishedAt: "2026-09-08 21:05",
    dateLabel: "9月8日",
    readTime: 6,
    heat: 44100,
    isTop: false,
    tags: ["头条专递", "黑马剧", "排播"],
    image:
      "https://readdy.ai/api/search-image?query=warm%20abstract%20film%20strip%20light%20leak%20texture%20in%20amber%20and%20sepia%20tones%2C%20minimal%20artistic%20background%2C%20no%20people%2C%20editorial%20grain&width=800&height=520&seq=gt-art-09&orientation=landscape",
    body: [
      {
        heading: "意外走红",
        paragraphs: [
          "剧集上线首周播放量平平，第二周开始出现明显的自然增长。转折点出现在一批剧情解析视频的集中发布。",
        ],
      },
      {
        heading: "平台动作",
        paragraphs: [
          "平台在热度攀升后宣布追加首页推荐位，并将原定的一次性放出调整为分批更新，以延长讨论周期。",
        ],
      },
    ],
  },
  {
    id: "br-2026-0908-10",
    title: "颁奖季首站落幕，最大悬念留到最后一刻才揭晓",
    summary: "年度首个重要奖项揭晓，此前呼声最高的作品与最终结果出现偏差，现场反应值得玩味。",
    channel: "breaking",
    channelName: "突发专报",
    author: "瓜田速递 · 前线组",
    publishedAt: "2026-09-08 23:50",
    dateLabel: "9月8日",
    readTime: 5,
    heat: 47200,
    isTop: false,
    tags: ["突发专报", "颁奖", "悬念"],
    image:
      "https://readdy.ai/api/search-image?query=elegant%20abstract%20golden%20trophy%20bokeh%20lights%20on%20dark%20warm%20background%2C%20no%20people%2C%20luxurious%20editorial%20still%20life%2C%20rich%20amber%20highlights&width=800&height=520&seq=gt-art-10&orientation=landscape",
    body: [
      {
        heading: "结果出炉",
        paragraphs: [
          "揭晓环节安排在整场晚会的最后十分钟。当念出获奖名字时，现场出现了短暂停顿，随后才是掌声。",
        ],
      },
      {
        heading: "业内怎么看",
        paragraphs: [
          "多位业内人士认为，结果虽有意外，但并未脱离评审一贯的口味偏好。真正的讨论焦点，可能在于评选标准是否应该更透明。",
        ],
      },
    ],
  },
  {
    id: "fl-2026-0907-11",
    title: "工作室否认解散传闻，称团队只是常规调整",
    summary: "针对社群中流传的团队解散说法，工作室简短回应：人员有调整，但项目照常推进。",
    channel: "flash",
    channelName: "紧急插播",
    author: "瓜田速递 · 前线组",
    publishedAt: "2026-09-07 15:40",
    dateLabel: "9月7日",
    readTime: 3,
    heat: 29800,
    isTop: false,
    tags: ["紧急插播", "传闻", "官方回应"],
    image:
      "https://readdy.ai/api/search-image?query=abstract%20office%20desk%20with%20warm%20lamp%20light%20and%20paper%20documents%2C%20no%20people%2C%20moody%20editorial%20interior%20photography%2C%20sepia%20and%20ember%20tones&width=800&height=520&seq=gt-art-11&orientation=landscape",
    body: [
      {
        heading: "传闻内容",
        paragraphs: [
          "传闻称团队核心成员集体离职，并附上了若干张无法核实的截图作为依据。",
        ],
      },
      {
        heading: "官方回应",
        paragraphs: [
          "工作室回应表示，人员属于常规轮换调整，目前多个项目仍在正常推进，希望外界不要过度解读。",
        ],
      },
    ],
  },
  {
    id: "dp-2026-0907-12",
    title: "深挖：热搜是怎么被做出来的，一条话题的完整旅程",
    summary: "从一条普通帖子到登上热搜榜，中间经历了什么？我们复盘了一个话题从零到爆的完整链路。",
    channel: "deep",
    channelName: "深度瓜情",
    author: "瓜田速递 · 深度组",
    publishedAt: "2026-09-07 10:15",
    dateLabel: "9月7日",
    readTime: 11,
    heat: 38500,
    isTop: false,
    tags: ["深度瓜情", "热搜", "传播链路"],
    image:
      "https://readdy.ai/api/search-image?query=abstract%20fiber%20optic%20light%20network%20in%20warm%20orange%20and%20deep%20red%2C%20no%20people%2C%20futuristic%20minimal%20texture%2C%20editorial%20dark%20background&width=800&height=520&seq=gt-art-12&orientation=landscape",
    body: [
      {
        heading: "起点往往很小",
        paragraphs: [
          "复盘显示，话题的起点通常是一条互动量平平的帖子。真正的转折，来自第一批转发者的账号结构。",
        ],
      },
      {
        heading: "三个扩散阶段",
        paragraphs: [
          "第一阶段是核心圈层的集中转发，第二阶段是垂类账号的加入，第三阶段才会扩散到大众视野。",
          "值得注意的是，第二阶段的窗口期通常只有数小时，错过后再想推动就难上加难。",
        ],
      },
    ],
  },
];

export const hotRanking = [
  { id: "br-2026-0912-01", title: "顶流工作室深夜发声明，合约风波迎来首次正面回应", heat: 98600 },
  { id: "fl-2026-0912-02", title: "演唱会安可环节突然取消，票务方当晚给出处理方案", heat: 74200 },
  { id: "hl-2026-0911-03", title: "年度剧集大结局口碑反转，编剧团队首度回应争议桥段", heat: 66300 },
  { id: "br-2026-0910-05", title: "综艺录制现场物料外泄，节目组回应将启动核查流程", heat: 52700 },
  { id: "hl-2026-0910-06", title: "跨年晚会阵容名单流出，主创团队回应名单真伪", heat: 48900 },
  { id: "br-2026-0908-10", title: "颁奖季首站落幕，最大悬念留到最后一刻才揭晓", heat: 47200 },
];

export const topics = [
  {
    slug: "breaking",
    title: "合约与声明",
    count: 128,
    desc: "围绕合约、声明与官方回应的系列追踪，时间线一页看懂。",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20warm%20paper%20documents%20and%20sealing%20wax%20on%20wooden%20desk%2C%20no%20people%2C%20moody%20editorial%20still%20life%2C%20terracotta%20and%20amber%20tones&width=800&height=600&seq=gt-topic-01&orientation=landscape",
  },
  {
    slug: "flash",
    title: "舞台与现场",
    count: 96,
    desc: "演唱会、音乐节与晚会现场的第一手动态与后续处理。",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20stage%20spotlights%20and%20haze%20in%20warm%20gold%20tones%2C%20no%20people%2C%20cinematic%20empty%20venue%2C%20editorial%20photography&width=800&height=600&seq=gt-topic-02&orientation=landscape",
  },
  {
    slug: "headline",
    title: "剧集与综艺",
    count: 154,
    desc: "剧集综艺的口碑走向、排播变化与主创回应。",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20warm%20cinema%20curtain%20folds%20and%20projector%20beam%2C%20no%20people%2C%20rich%20burgundy%20and%20gold%20editorial%20texture&width=800&height=600&seq=gt-topic-03&orientation=landscape",
  },
  {
    slug: "deep",
    title: "脉络与复盘",
    count: 73,
    desc: "不追一时热点，专注把事件的前因后果讲清楚。",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20timeline%20threads%20of%20warm%20light%20connecting%20across%20dark%20surface%2C%20no%20people%2C%20minimal%20conceptual%20editorial%20art&width=800&height=600&seq=gt-topic-04&orientation=landscape",
  },
];

export const siteStats = [
  { label: "每日更新瓜情", value: "320+", unit: "条" },
  { label: "突发专报平均首发", value: "6", unit: "分钟" },
  { label: "累计吃瓜用户", value: "218", unit: "万" },
  { label: "覆盖频道", value: "4", unit: "个" },
];

export const testimonials = [
  {
    name: "阿柚",
    role: "夜班编辑部",
    text: "最烦的就是各平台信息前后矛盾。这里把时间线列出来，谁先谁后一眼就清楚，省了我大量核对时间。",
  },
  {
    name: "老周",
    role: "资深吃瓜群众",
    text: "突发专报发得快是真的，好几次朋友圈还在传截图，这边已经把官方回应贴出来了。",
  },
  {
    name: "小林",
    role: "内容运营",
    text: "深度瓜情那几篇复盘写得很克制，不煽风点火，只把事情讲明白，比看一堆情绪化帖子舒服多了。",
  },
];

export const faqs = [
  {
    q: "瓜田速递主要提供什么内容？",
    a: "我们围绕突发专报、紧急插播、头条专递与深度瓜情四个方向，聚合正在发生的文娱动态，并提供可核对的时间线与官方回应，帮助你在吃瓜前线快人一步。",
  },
  {
    q: "信息更新有多快？",
    a: "突发类内容通常在事件出现确凿信源后六分钟内完成首发，紧急插播为随到随更。深度内容因为需要交叉核对，会稍慢一些，但会保证脉络完整。",
  },
  {
    q: "内容会不会带有主观倾向？",
    a: "我们的原则是先给事实、再给背景。多方说法会并列呈现，不替任何一方下结论；如果信息尚不确定，会在文中明确标注。",
  },
  {
    q: "可以投稿或者爆料吗？",
    a: "可以。你可以通过页面底部的联系邮箱提交线索，我们会安排编辑进行核实。真实有效的线索，我们会优先安排跟进。",
  },
  {
    q: "订阅之后会收到什么？",
    a: "订阅后你会在每个重要瓜情节点收到一封简报，包含当天最值得关注的进展与脉络摘要，不做无关推送，随时可以退订。",
  },
];